import { axios } from '@Root/API'

export const autoMapFields = payload => {
  return axios.post('cognito-form-field-mappings/auto-map', payload)
}
